import Button, { ButtonVariant } from '@/components/BaseLibrary/Button/Button';
import useStyles from '@/components/InteractiveQuoteForm/InteractiveQuoteForm.styles';
import { OwnHome } from '@/hooks/useSubmitLeadToZeus';
import { trackEvents } from '@/utils/analytics';

export interface ZipCodeStepProps {
  handleNext: (data: OwnHome) => void;
}

export default function ZipCodeStep({ handleNext }: ZipCodeStepProps) {
  const { classes } = useStyles();

  const onSubmit = (data: OwnHome) => {
    trackEvents({
      event: 'Form_cta_click',
      Form_tab: 'Home Ownership',
      Form_step: 2,
      click_text: 'Yes',
    });
    handleNext(data);
  };

  return (
    <div className={classes.inputContainer}>
      <Button
        onClick={() => onSubmit(OwnHome.OWN)}
        label='Yes'
        className={classes.button}
      />
      <div className={classes.buttonContainer}>
        <Button
          onClick={() => onSubmit(OwnHome.RENT)}
          variant={ButtonVariant.SECONDARY}
          label='No'
          className={classes.button}
        />
      </div>
    </div>
  );
}
